import { render, staticRenderFns } from "./cards-horizontal-carousel.vue?vue&type=template&id=55bc10a4&"
import script from "./cards-horizontal-carousel.vue?vue&type=script&lang=js&"
export * from "./cards-horizontal-carousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports